import React, { useState } from 'react';
import { LiveIndicator } from '../components/LiveIndicator';
import { VideoPlayer } from '../components/VideoPlayer';
import { CountdownTimer } from '../components/CountdownTimer';
import { ActionButton } from '../components/ActionButton';
import { GiftIcon, X } from 'lucide-react';
import { BonusCard } from '../components/BonusCard';
import { PricingCard } from '../components/PricingCard';
import { ValueSummary } from '../components/ValueSummary';
import { CompleteSystemOffer } from '../components/CompleteSystemOffer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { FAQ } from '../components/FAQ';
import { CaseStudyVideo } from '../components/CaseStudyVideo';
import { TestimonialSection } from '../components/TestimonialSection';
export function ReplayPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <div className="min-h-screen" data-id="element-3549">
      {/* Dark section - Header, Video, CTA */}
      <div className="bg-gradient-to-b from-gray-900 to-black text-white" data-id="element-3550">
        <div className="container mx-auto px-4 py-12 max-w-5xl" data-id="element-3551">
          <div className="flex justify-center mb-6" data-id="element-3552">
            <LiveIndicator data-id="element-3553" />
          </div>
          <div className="text-center mb-8" data-id="element-3554">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" data-id="element-3555">
              Cómo Generar de $500-$1000/día con el poder de la Inteligencia
              Artificial
            </h1>
            <p className="text-xl text-gray-300 mt-4" data-id="element-3556">
              Masterclass exclusiva: Aprende estrategias probadas para generar
              ingresos con IA
            </p>
          </div>
          <div className="overflow-hidden mb-8" style={{
          boxShadow: '0 0 40px rgba(34, 197, 94, 0.6), 0 0 80px rgba(34, 197, 94, 0.4), 0 20px 100px rgba(34, 197, 94, 0.3)'
        }} data-id="element-3557">
            <VideoPlayer data-id="element-3558" />
          </div>
          <div className="mt-8 text-center pb-12" data-id="element-3559">
            <CountdownTimer data-id="element-3560" />
            <div className="mt-8" data-id="element-3561">
              <ActionButton data-id="element-3562" />
            </div>
          </div>
        </div>
      </div>
      {/* White section - Bonus images and gift button */}
      <div className="bg-white" data-id="element-3563">
        <div className="container mx-auto px-4 py-12 max-w-5xl" data-id="element-3564">
          <div className="mt-8" data-id="element-3565">
            <PricingCard data-id="element-3566" />
            {/* Case Study Video */}
            <CaseStudyVideo data-id="element-3567" />
            {/* Testimonial Section */}
            <TestimonialSection data-id="element-3568" />
            <BonusCard bonusNumber={1} title="BOVEDA DE AI PROMPTS" description="Más de 1,000 prompts probados y optimizados para IA. Copia y pega para obtener resultados instantáneos en tus campañas y contenidos." imageSrc="https://cdn.magicpatterns.com/uploads/xi8Aqi4p2fcNffNAdv6eaW/Screenshot_2026-01-08_at_11.01.25_PM.png" data-id="element-3569" />
            <BonusCard bonusNumber={2} title="AI PRODUCT ROLODEX" description="La Lista de 60 productos digitales y nichos validados listos para lanzar. Nicho, avatar, targeting, ads, todo." imageSrc="https://cdn.magicpatterns.com/uploads/dQQyhq5ofiFSdVHXGevL5m/Screenshot_2026-01-08_at_11.00.51_PM.png" data-id="element-3570" />
            <BonusCard bonusNumber={3} title="PLANTILLAS DFY COPYWRITING" description="Plantillas DFY Copy hechas para ti." features={['VSL Scripts', 'Sales Copywriting', 'Email and SMS copy', 'Abandonment Cart']} imageSrc="https://cdn.magicpatterns.com/uploads/rjrfMP1TNvhRaA5Ge8vaTi/c760a89c-ca2b-42bf-9bb2-fffe9652a3d5.png" data-id="element-3571" />
            <BonusCard bonusNumber={4} title="AI INCOME CALCULATOR" description="Calculadora para calcular los ingresos de tu funnel y productos digitales." features={['Click Roas', 'AOV', 'LTV']} imageSrc="https://cdn.magicpatterns.com/uploads/sbsgqc4DbHfc6rMsr661hd/0b3c81b5-279c-4857-99ab-94f80e2fc784.png" data-id="element-3572" />
            <BonusCard bonusNumber={5} title="VIRAL VIDEO MACHINE" description="Crea Videos Virales con AI. Sin grabar, sin editar, sin diseñar. Nada. Todo hecho por IA." features={['Videos que han tenido millones de views y ventas']} imageSrc="https://cdn.magicpatterns.com/uploads/v1Fv9jrn3PZg3qgffKZ7PN/f2daf09f-8d0d-419a-a6db-476b7c45c64e.png" data-id="element-3573" />
            <ValueSummary data-id="element-3574" />
            <CompleteSystemOffer data-id="element-3575" />
          </div>
          {/* FAQ Section */}
          <FAQ data-id="element-3576" />
          <div className="text-center mt-8" data-id="element-3577">
            <ActionButton data-id="element-3578" />
          </div>
          <div className="text-center mt-8" data-id="element-3579">
            <a href="https://regalo.marketingconia.live/" target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#06b6d4] to-[#0891b2] hover:from-[#0891b2] hover:to-[#0e7490] text-white font-bold py-4 px-8 rounded-lg text-xl transition-all transform hover:scale-105 shadow-lg hover:shadow-xl" data-id="element-3580">
              <GiftIcon className="w-6 h-6" data-id="element-3581" />
              ¡Reclama Tu Regalo Gratis!
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="w-full relative z-10 bg-black border-t border-gray-800" data-id="element-3582">
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-4 md:py-6" data-id="element-3583">
          {/* Legal Disclaimer */}
          <div className="text-gray-400 text-[10px] leading-tight space-y-2 text-left" data-id="element-3584">
            <p data-id="element-3585">
              48 HRS AI CASH MACHINE y todo el equipo asociado no asume
              responsabilidad por los resultados, ingresos o éxito que puedas
              obtener, ni garantiza resultados específicos. El éxito depende en
              parte del tiempo que dediques y de tu implementación de las guías,
              estrategias y soporte proporcionados. Todo el contenido,
              entrenamientos, artículos y material educativo tiene fines
              formativos únicamente y no debe interpretarse como asesoría
              financiera, legal o de inversión.
            </p>

            <p data-id="element-3586">
              Aunque nuestros servicios, sistemas y productos están diseñados
              para ayudar a nuestros clientes a crear y lanzar productos
              digitales con IA, no ofrecemos garantías (explícitas o implícitas)
              sobre resultados, ventas o ingresos derivados del uso de las
              ideas, herramientas o estrategias presentadas.
            </p>

            <p data-id="element-3587">
              Los testimonios compartidos corresponden a experiencias reales de
              usuarios, pero no deben considerarse como resultados típicos, ya
              que cada persona obtiene resultados diferentes según su situación
              y las acciones que decida tomar.
            </p>

            <p data-id="element-3588">
              Cualquier cifra interna, ejemplo o caso de estudio mostrado tiene
              fines ilustrativos y no garantiza que tú obtendrás los mismos
              resultados.
            </p>

            <p data-id="element-3589">
              Este sitio no forma parte de Google, Google Inc., Facebook/Meta o
              Meta Inc.
            </p>

            <p data-id="element-3590">
              Además, este sitio no está avalado, patrocinado ni aprobado por
              Google ni Meta de ninguna manera.
            </p>
          </div>

          {/* Copyright */}
          <div className="text-center mt-4 pt-3 border-t border-gray-800" data-id="element-3591">
            <p className="text-gray-600 text-[10px] mb-1" data-id="element-3592">
              &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
            </p>
            <p className="text-gray-500 text-[10px] mb-1" data-id="element-3593">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#06b6d4] hover:text-[#0891b2] transition-colors" data-id="element-3594">
                support@truemarketer.com
              </a>
            </p>
            <div className="flex items-center justify-center gap-4 text-[10px]" data-id="element-3595">
              <button onClick={() => setShowTerms(true)} className="text-gray-500 hover:text-white transition-colors underline" data-id="element-3596">
                Términos
              </button>
              <span className="text-gray-600" data-id="element-3597">|</span>
              <button onClick={() => setShowPrivacy(true)} className="text-gray-500 hover:text-white transition-colors underline" data-id="element-3598">
                Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp Button */}
      <WhatsAppButton data-id="element-3599" />

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-3600">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-3601">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-3602">
              <X className="w-6 h-6" data-id="element-3603" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-3604">
              Términos y Condiciones
            </h2>
            <div className="text-gray-300 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-3605">
              <p data-id="element-3606">
                Al registrarte y participar en el 48 Hrs AI Cash Machine
                Masterclass, aceptas los siguientes términos y condiciones:
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3607">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-3608">
                Al acceder y utilizar este sitio web y registrarte para el
                evento, aceptas estar sujeto a estos términos y condiciones,
                todas las leyes y regulaciones aplicables.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3609">
                2. Uso del Servicio
              </h3>
              <p data-id="element-3610">
                El contenido proporcionado en el masterclass es solo para fines
                educativos e informativos. No garantizamos resultados
                específicos de ingresos o éxito comercial.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3611">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-3612">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de 48 Hrs AI Cash Machine y están protegidos por
                derechos de autor. No está permitida la reproducción o
                distribución sin autorización expresa.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3613">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-3614">
                48 Hrs AI Cash Machine no será responsable de ningún daño
                directo, indirecto, incidental o consecuente que resulte del uso
                o la imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3615">
                5. Modificaciones
              </h3>
              <p data-id="element-3616">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. El uso continuado del servicio después de
                cambios constituye la aceptación de los nuevos términos.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3617">Contacto</h3>
              <p data-id="element-3618">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-3619">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-3620">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-3621">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-3622">
              <X className="w-6 h-6" data-id="element-3623" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-3624">
              Política de Privacidad
            </h2>
            <div className="text-gray-300 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-3625">
              <p data-id="element-3626">
                En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
                privacidad. Esta política describe cómo recopilamos, usamos y
                protegemos tu información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3627">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-3628">
                Recopilamos información que nos proporcionas directamente,
                incluyendo:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-3629">
                <li data-id="element-3630">Nombre y dirección de correo electrónico</li>
                <li data-id="element-3631">Información de registro del evento</li>
                <li data-id="element-3632">Comunicaciones que mantienes con nosotros</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3633">
                2. Uso de la Información
              </h3>
              <p data-id="element-3634">Utilizamos tu información para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-3635">
                <li data-id="element-3636">
                  Proporcionar acceso al masterclass y materiales relacionados
                </li>
                <li data-id="element-3637">Enviar comunicaciones sobre el evento</li>
                <li data-id="element-3638">Mejorar nuestros servicios y contenido</li>
                <li data-id="element-3639">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3640">
                3. Compartir Información
              </h3>
              <p data-id="element-3641">
                No vendemos ni compartimos tu información personal con terceros
                para fines de marketing. Podemos compartir información con
                proveedores de servicios que nos ayudan a operar nuestro
                negocio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3642">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-3643">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas para proteger tu información personal contra acceso
                no autorizado, alteración o destrucción.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3644">
                5. Tus Derechos
              </h3>
              <p data-id="element-3645">
                Tienes derecho a acceder, corregir o eliminar tu información
                personal. Para ejercer estos derechos, contáctanos en:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-3646">
                  support@truemarketer.com
                </a>
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3647">6. Cookies</h3>
              <p data-id="element-3648">
                Utilizamos cookies y tecnologías similares para mejorar tu
                experiencia en nuestro sitio web y analizar el uso del sitio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3649">Contacto</h3>
              <p data-id="element-3650">
                Para preguntas sobre esta política de privacidad, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-3651">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}
    </div>;
}